import { IDocumentEditable } from "..";
import { ItemSet, InitialSettingKinds } from "../../../../domain/document";
import { DateItem, instanceOfIHisInformationApplicable } from "../../../../domain/document/items";
import { FuzzyDate } from "../../../../domain/system";
import { HisInformation } from "../../../../domain/his";

export class InitialSettingCreateDateApplicator {
  constructor(private document: IDocumentEditable) {}
  
  apply(info: HisInformation): void {
    const itemSet = this.getDateItems(this.document.itemSets);
    const applicableItemSet = itemSet.map(items => items.filter((item) => this.isApplicableCreateDate(item, info)));
    const today = new Date();
    for (let itemSetId = 0; itemSetId < applicableItemSet.length; itemSetId++) {
      const items = applicableItemSet[itemSetId];
      for (const item of items) {
        if (item.value instanceof FuzzyDate) {
          const cloned = item.clone() as DateItem;
          cloned.value.value = today;
          this.document.updateItem(cloned, {
            itemSetId,
          });
        }
      }
    }
  }

  private getDateItems(itemSets: ItemSet[]): DateItem[][] {
    return itemSets.map(itemSet => 
      itemSet.items.filter(this.isDateItem)
    );
  }

  private isApplicableCreateDate(item: DateItem, info: HisInformation): boolean {
    // HIS項目として項目が含まれている場合は上書きしない（ワークフロー記載のときの作成日を除外したい）
    if (this.isHisUpdateItem(item, info)) {
      return false;
    }
    return item.isInitial
      && item.initialSettingKind === InitialSettingKinds.CreateDate;
  }

  private isDateItem(instance: any): instance is DateItem {
    return instance instanceof DateItem;
  }

  private isHisUpdateItem(item: DateItem, info: HisInformation): boolean {
    return instanceOfIHisInformationApplicable(item)
      && (item.hisItemParameter != null)
      && (info.items.filter(i => i.name === item.hisItemParameter.key).length !== 0);
  }
}
